import FileUpload from "components/UploadArquivos";
import { useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import { InformeFaturamentoContext } from "../../context/InformeFaturamentoContext";
import { Button, ButtonImportar } from "./style";

export function Importar() {
  const { setArquivo, importar, linhas } = useContext(InformeFaturamentoContext);

  function handleBaixarModelo() {
    const link = document.createElement("a");
    link.download = "Informe_Faturamento.xlsx";
    link.href = "/app/files/Informe_Faturamento.xlsx";
    link.click();
  }

  return (
    <div className="bg-white p-4">
      <p>Faça o upload da planilha (Excel) para importar o informe de faturamento</p>
      <Row>
        <Col md={5}>
          <Form.Group>
            <Form.Label>Arquivo (Excel)</Form.Label>
            <FileUpload
              onFileUpload={setArquivo}
              comMaxWidth={true}
              gapContainer="0"
              inputAccept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              limparArquivo={linhas.length === 0}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Button outline variante="primary" type="button" onClick={handleBaixarModelo}>
            <FaDownload /> Baixar Modelo
          </Button>
        </Col>
        <Col md={3}>
          <ButtonImportar variante="primary" type="button" onClick={importar}>
            Importar Excel
          </ButtonImportar>
        </Col>
      </Row>
    </div>
  );
}
